import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import {
  ReceiptAgent,
  ReceiptAgentCaseDecisionResponse,
  ReceiptAgentCaseResponse,
  ReceiptAgentRun,
  SubmitReceiptAgentCaseDecisionParams,
} from 'src/queries/organizations/receiptAgent/receiptAgent.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export const getReceiptAgent = async (
  organizationId: string,
): Promise<ReceiptAgent> =>
  getResponseData(
    axios.get<ReceiptAgent>(
      `/organizations/${organizationId}/receipt-agent`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const getReceiptAgentRuns = async (
  organizationId: string,
  accountingPeriodId: string,
): Promise<ReceiptAgentRun[]> =>
  getResponseData(
    axios.get<ReceiptAgentRun[]>(
      `/organizations/${organizationId}/receipt-agent/runs`,
      {
        ...getRequestConfig(RequestConfig.Default),
        params: { accountingPeriodId },
      },
    ),
  )

export const startReceiptAgentRun = async (
  organizationId: string,
  accountingPeriodId: string,
): Promise<ReceiptAgentRun> =>
  getResponseData(
    axios.post<ReceiptAgentRun>(
      `/organizations/${organizationId}/receipt-agent/runs`,
      undefined,
      {
        ...getRequestConfig(RequestConfig.Default),
        params: { accountingPeriodId },
      },
    ),
  )

export const getReceiptAgentCase = async (
  organizationId: string,
  caseId: string,
): Promise<ReceiptAgentCaseResponse> =>
  getResponseData(
    axios.get<ReceiptAgentCaseResponse>(
      `/organizations/${organizationId}/receipt-agent/cases/${caseId}`,
      getRequestConfig(RequestConfig.Default),
    ),
  )

export const submitReceiptAgentCaseDecision = async ({
  organizationId,
  caseId,
  decision,
  expectedVersion,
}: SubmitReceiptAgentCaseDecisionParams): Promise<ReceiptAgentCaseDecisionResponse> =>
  getResponseData(
    axios.post<ReceiptAgentCaseDecisionResponse>(
      `/organizations/${organizationId}/receipt-agent/cases/${caseId}/decision`,
      { decision, expectedVersion },
      getRequestConfig(RequestConfig.Default),
    ),
  )
